import { createElement, useEffect } from 'react';

import FilePreview, { Props as FilePreviewProps } from '@components/FilePreview';
import { FormattedMessage } from 'utils/intl';
import useBoolean from 'hooks/useBoolean';

import classes from './GltfFilePreview.module.scss';
import messages from './GltfFilePreview.messages';

type Props = Omit<FilePreviewProps, 'fileType' | 'preview'>;

const GltfFilePreview = ({
  additionalButton,
  classes: customClasses,
  fileName,
  fileUrl,
  downloadFileName,
  headerComponent,
}: Props): JSX.Element => {
  const [isViewerLoaded, { on }] = useBoolean(false);

  useEffect(() => {
    const init = async () => {
      await import('@google/model-viewer');
      on();
    };

    init();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <FilePreview
      fileType="GLTF"
      fileName={fileName}
      fileUrl={fileUrl}
      downloadFileName={downloadFileName}
      classes={customClasses}
      downloadMessage={<FormattedMessage {...messages.download} />}
      headerComponent={headerComponent}
      additionalButton={additionalButton}
      preview={
        <div className={customClasses?.object}>
          {isViewerLoaded &&
            createElement('model-viewer', {
              alt: fileName,
              src: fileUrl,
              class: classes.model,
              'touch-action': 'pan-y',
              'shadow-intensity': '1',
              'with-credentials': true,
              'camera-controls': true,
            })}
        </div>
      }
    />
  );
};

export default GltfFilePreview;
